var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AddFileDialog'),_c('NavigationDrawer'),_c('AppBar'),_c('NotificationSnackBar'),_c('CommentDialog'),_c('AboutDialog'),_c('DownloadDialog'),_c('v-main',[_c('v-container',{style:(_vm.router().currentRoute.name === 'map' ? 'margin: 0 !important; padding: 0 !important' : ''),attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }